export {
  STORE_KEY_ACCOUNT,
  STORE_KEY_ACCOUNT_DATA_RETENTION,
  STORE_KEY_ACCOUNT_OPTIONS,
  STORE_KEY_AUTH,
  STORE_KEY_ID_LIST,
  STORE_KEY_LANG,
  STORE_KEY_LIST,
  STORE_KEY_LISTS_COUNT,
  STORE_KEY_LOGIN_TYPE,
  STORE_KEY_SECURE_OPENER,
  STORE_KEY_USER,
  STORE_KEY_USER_LANG,
  STORE_KEY_USER_LISTS,
  STORE_KEY_USER_OPTIONS,
} from "mailup-react-helpers";

export const LOGIN_TYPE_WEBLOGIN = 0;
export const LOGIN_TYPE_ADM = 1;
export const LOGIN_TYPE_ADMLIMITED = 2;
export const LOGIN_TYPE_RESELLER = 3;

export const FILTER_TYPE_ANAGRAPHIC = "Anagraphic";
export const FILTER_TYPE_ACTIVITY = "Activity";
export const FILTER_TYPE_DEVICE = "Device";
export const FILTER_TYPE_GEOLOCATION = "Geolocation";
export const FILTER_TYPE_MULTIFILTER = "MultiFilter";
export const FILTER_TYPE_MULTITYPE = "MultiType";
export const FILTER_TYPE_ENGAGEMENT = "Engagement";
export const FILTER_TYPE_TRACKING = "Tracking";

export const MATCH_FILTER_CONDITION_ALL = "All";
export const MATCH_FILTER_CONDITION_AT_LEAST_ONE = "AtLeastOne";

export const MOVECOPY_OPTION_ADD = "add";
export const MOVECOPY_OPTION_REMOVE_FROM_SELECTED = "remove-from-selected";
export const MOVECOPY_OPTION_REMOVE_FROM_ALL = "remove-from-all";

export const EMAIL_OPTOUT_TYPE_ALL = -1;
export const EMAIL_OPTOUT_TYPE_CONSOLE = 0;
export const EMAIL_OPTOUT_TYPE_UNSUBSCRIBE = 2;
export const EMAIL_OPTOUT_TYPE_IMPORT = 4;
export const EMAIL_OPTOUT_TYPE_BOUNCE = 8;
export const EMAIL_OPTOUT_TYPE_EMAILERRATA = 81;
export const EMAIL_OPTOUT_TYPE_DOMINIOERRATO = 82;
export const EMAIL_OPTOUT_TYPE_CASELLAABBANDONATA = 83;
export const EMAIL_OPTOUT_TYPE_FEEDBACKLOOP = 16;
export const EMAIL_OPTOUT_TYPE_LISTUNSUBSCRIBEPAGE = 32;
export const EMAIL_OPTOUT_TYPE_LISTUNSUBSCRIBEMAILTO = 64;
export const EMAIL_OPTOUT_TYPE_RECIPIENTINACTIVE = 128;
export const EMAIL_OPTOUT_TYPE_BLOCKEDEMAIL = 256;
export const EMAIL_OPTOUT_TYPE_BLOCKEDEMAILMTA = 2561;
export const EMAIL_OPTOUT_TYPE_BLOCKEDEMAILSPAM = 2562;
export const EMAIL_OPTOUT_TYPE_BLOCKEDEMAILCONFIGMTA = 2563;
export const EMAIL_OPTOUT_TYPE_CONTINUALBOUNCES = 512;
export const EMAIL_OPTOUT_TYPE_PROVISIONALCONTBOUNCES = 5121;
export const EMAIL_OPTOUT_TYPE_DEFINITIVECONTBOUNCES = 5122;
export const EMAIL_OPTOUT_TYPE_RIGHTTOBEFORGOTTEN = 1024;

export const SMS_OPTOUT_TYPE_ALL = -1;
export const SMS_OPTOUT_TYPE_CONSOLE = 0;
export const SMS_OPTOUT_TYPE_UNSUBSCRIBE = 2;
export const SMS_OPTOUT_TYPE_IMPORT = 4;
export const SMS_OPTOUT_TYPE_BOUNCE = 8;
export const SMS_OPTOUT_TYPE_RIGHTTOBEFORGOTTEN = 1024;

export const INPUT_MESSAGES_MAX_ITEMS = 100;

export const CHANNEL_EMAIL = "email";
export const CHANNEL_SMS = "sms";

export const ACTIVITY_EVENT_TYPES = [
  "Subscription",
  "SubscriptionRequest",
  "SubscriptionConfirmation",
  "Unsubscription",
  "Clicks",
  "Bounces",
  "Opens",
  "Sendings",
];

export const ACTIVITY_EVENT_TYPE_SUBSCRIPTIONREQUEST = "SubscriptionRequest";
export const ACTIVITY_EVENT_TYPE_SUBSCRIPTIONCONFIRMATION =
  "SubscriptionConfirmation";
export const ACTIVITY_EVENT_TYPE_SUBSCRIPTION = "Subscription";
export const ACTIVITY_EVENT_TYPE_UNSUBSCRIPTION = "Unsubscription";
export const ACTIVITY_EVENT_TYPE_OPENS = "Opens";
export const ACTIVITY_EVENT_TYPE_CLICKS = "Clicks";
export const ACTIVITY_EVENT_TYPE_BOUNCES = "Bounces";
export const ACTIVITY_EVENT_TYPE_SENDINGS = "Sendings";

export const offerType = {
  Undefined: 0,
  Banda: 1,
  Frequenza: 2,
  StarterEdition: 3,
  PlusEdition: 4,
  EnterpriseEdition: 5,
  SoloSMS: 6,
  PremiumEdition: 7,
  LightEdition: 8,
};

export const DEFAULT = "default";
export const SUCCESS = "success";
export const INFO = "info";
export const WARNING = "warning";
export const ERROR = "error";

export const RECIPIENTS_LIST_LABEL = "Load.NavMenu.RecipientsList"; // 'Load.MailupCommon.All'

export const STORE_KEY__RECIPIENTS_LIST_MODAL_DELETE_PREFS =
  "recipients-list__modal-delete-prefs";

export const DELIVERABILITY_INDEX_TYPE_AUDIT = "Audit";

export const STRIP_HTML_TAG = /<\/?[^>]+(>|$)/g;

export const FATTURE_IN_CLOUD_INTEGRATION_ID =
  "2050106c-11d0-f8da-86d1-26bce7c220e5";

export const APP_CLIENT_ID = "2fdc562f-3a4f-4fe1-bf9f-00f426c6d715";

export const ACCEPTED_FILE_IMPORT_EXT = [
  ".csv",
  ".txt",
  ".xls",
  ".xlsx",
  ".xml",
];
export const FILE_IMPORT_MAX_SIZE = 20000000;
